import React from "react";

function Project(props) {

    const {data} = props

    return (
        <a
            data-aos="fade-zoom-in" data-aos-delay='200' data-aos-duration='1500'
            className="Project" href={data.link} target="_blank" rel="noreferrer"
        >
            <img src={data.img} alt=''/>
        </a>
    )
}
export default Project